<template>
  <div class="card">
    <div class="card-body">
      <router-link class="close" :to="'/' + 'products/' + $i18n.locale"></router-link>
      <h5 class="create-title">{{ $t('addNewSupplier') }}</h5>
      <form @submit.prevent="createSupplier">
        <!--@submit.prevent="createProduct" to trigger event when click "submit"-->
        <input
          class="field"
          v-model="supplier.name"
          type="text"
          maxlength="30"
          :placeholder="$t('addSupplierName')"
          :class="{ 'error-boarder': $v.supplier.name.$error }"
          @blur="$v.supplier.name.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.supplier.name.$error">
          <p v-if="!$v.supplier.name.required" class="errorMessage">
            {{ $t('supplierNameReq') }}
          </p>
        </template>
        
        <accordion>
          <accordion-item>
            <template slot="accordion-trigger">
              <h5 class="optionalTag">{{ $t('addOptionalData') }}</h5>
            </template>
            <template slot="accordion-content">
              <div class="optionalData">
                <p class="optional">{{ $t('optional') }}</p>
                <input
                  class="field bgOptional"
                  v-model="supplier.vat_no"
                  type="text"
                  :placeholder="$t('vatNo')"
                  :class="{ error: $v.supplier.vat_no.$error }"
                  @blur="$v.supplier.vat_no.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.vat_no.$error">
                  <p v-if="!$v.supplier.vat_no.required" class="errorMessage">
                    VAT number is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.contact_fname"
                  type="text"
                  :placeholder="$t('contactFname')"
                  :class="{ error: $v.supplier.contact_fname.$error }"
                  @blur="$v.supplier.contact_fname.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.contact_fname.$error">
                  <p v-if="!$v.supplier.contact_fname.required" class="errorMessage">
                    Contact Person First Name is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.contact_lname"
                  type="text"
                  :placeholder="$t('contactLname')"
                  :class="{ error: $v.supplier.contact_lname.$error }"
                  @blur="$v.supplier.contact_lname.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.contact_lname.$error">
                  <p v-if="!$v.supplier.contact_lname.required" class="errorMessage">
                    Contact Person Last Name is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.contact_no"
                  type="text"
                  :placeholder="$t('contactNo')"
                  :class="{ error: $v.supplier.contact_no.$error }"
                  @blur="$v.supplier.contact_no.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.contact_no.$error">
                  <p v-if="!$v.supplier.contact_no.required" class="errorMessage">
                    Contact number is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.address"
                  type="text"
                  :placeholder="$t('address')"
                  :class="{ error: $v.supplier.address.$error }"
                  @blur="$v.supplier.address.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.address.$error">
                  <p v-if="!$v.supplier.address.required" class="errorMessage">
                    Business address is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.postal_code"
                  type="number"
                  :placeholder="$t('postalCode')"
                  :class="{ error: $v.supplier.postal_code.$error }"
                  @blur="$v.supplier.postal_code.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.postal_code.$error">
                  <p v-if="!$v.supplier.postal_code.required" class="errorMessage">
                    Postal code is required.
                  </p>
                </template> -->

                <input
                  class="field bgOptional"
                  v-model="supplier.city"
                  type="text"
                  :placeholder="$t('city')"
                  :class="{ error: $v.supplier.city.$error }"
                  @blur="$v.supplier.city.$touch()"
                />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.city.$error">
                  <p v-if="!$v.supplier.city.required" class="errorMessage">
                    City is required.
                  </p>
                </template> -->

                <p class="selectCountry">{{$t('selectCountry')}}</p>
                <country-select 
                  v-model="supplier.country" 
                  :country="supplier.country" 
                  class="field inputStyle bgOptional"
                  topCountry="SI"
                  :countryName="true"
                  :autocomplete="true"
                  :removePlaceholder="true"
                  :usei18n="false"
                  @blur="$v.supplier.country.$touch()"
                  />
                <!--Form validation-->
                <!-- <template v-if="$v.supplier.country.$error">
                  <p v-if="!$v.supplier.country.required" class="errorMessage">
                    Country is required.
                  </p>
                </template> -->
              </div>

              <br/>
            </template>
          </accordion-item>
        </accordion>
        <button
          type="submit"
          class="add-btn"
          :disabled="$v.$invalid"
          >{{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
      <sweet-modal icon="success" ref="modalSuccess">
        {{ $t('addedSupplierConf') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalError">
        {{ $t('errorMsg') }}
        <!-- <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button> -->
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import NProgress from 'nprogress'
import { required } from 'vuelidate/lib/validators'
import Accordion from '../components/common/accordion.vue'
import AccordionItem from "../components/common/accordion-item";
import { SweetModal } from 'sweet-modal-vue';

export default {
  components: { 
    Accordion,
    AccordionItem,
    SweetModal
   },
  data() {
    return {
      supplier: this.createFreshSupplierObject()
    }
  },
  validations: {
    supplier: {
      name: { required },
      vat_no: { },
      contact_fname: { },
      contact_lname: { },
      contact_no: { },
      address: { },
      postal_code: { },
      city: { },
      country: { }
    }
  },
  methods: {
    createSupplier() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        if (this.supplier.postal_code === "") this.supplier.postal_code = null
        this.$store
          .dispatch('supplier/createSupplier', this.supplier)
          .then(() => {
            this.$refs.modalSuccess.open()
            if(!this.firstProductCreate)this.$router.push({ name: 'supplier-list' }) // automatically redirect to login when user click "register"//
            // this.$router.push({name: 'supplier', params: { id: this.supplier.supplierId }
            // }) //ERROR: posting in db.json OK, routing at submit click NOT WORKING //
            this.supplier = this.createFreshSupplierObject()
            this.$emit('success-supplier', {})
          })
          .catch(err => {
          this.errors = err.response.data.errors
          this.$refs.modalError.open()
          })
          .catch(() => {
            NProgress.done()
          })
      }
    },
    createFreshSupplierObject() {
      const client = this.$store.state.client.client
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        client_id: client,
        name: '',
        vat_no: '',
        contact_fname: '',
        contact_lname: '',
        contact_no: '',
        address: '',
        postal_code: '',
        city: '',
        country: ''
      }
    }
  },
  props: {
    firstProductCreate: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

.add-btn {
	margin-top: 1em;
	background: var(--primaryDark);
	color: var(--bright);
	letter-spacing: 8px;
	width: 200px;
	text-transform: uppercase;
	padding: 15px;
	border-radius: 5px;
	font-size: 1.6em;
}

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 60px 30px 60px;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  margin-top: 1em;
  color: var(--bg);
}
.optionalTag {
  text-align: center !important;
  background-color: var(--grey-light);
  padding: 8px;
}

ul {
    padding-left: 0px !important;
}

form {
  width: 55%;
}
input {
  background: none;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.bgOptional {
  background: rgb(252, 250, 250);
}

.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.error-boarder {
  border: 2px solid var(--primaryDark) !important;
}

.field {
  display: block;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-bottom: 1em;
  font: 1em 'Lato', Helvetica, sans-serif;
}


.close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.create-title {
  font-weight: 600;
  font-size: 2.5em;
  margin-top: 20px;
}
p {
  text-align: left;
}

.error {
  background-color:none !important;
  border-color: none !important;
}

.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

.selectCountry {
  text-align: left;
  margin-bottom: 0px;
}

@media screen and (min-width: 560px){
.close {
  display: none;
}
}

@media screen and (min-width : 560px) and (max-width : 950px) and (orientation : landscape)  {
  form {
  width: 80%;
}
}

@media screen and (max-width: 560px){
  form {
  width: 100%;
  padding: 10px;
}
.optionalData {
    padding: 0 20px 10px 20px;
  }
.create-title {
  font-size: 1.8em;
  margin-top: 60px;
  margin-bottom: 20px;
}
.field {
  margin-bottom: 15px;
}
.add-btn {
  margin-top: 50px;
  width: 100%;
  letter-spacing: 6px;
  padding: 10px;
  font-size: 1.5em;
}
}

</style>
